import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { Reassurance } from "../components/Reassurance";
import { Story } from "../components/Story";
import { Gourmandises } from "../components/Gourmandises";
import { LoyaltyBanner } from "../components/LoyaltyBanner";
import { Reviews } from "../components/Reviews";
import { ZoneLivraison } from "../components/ZoneLivraison";
import { Galerie } from "../components/Galerie";
import { FaqContact } from "../components/FaqContact";
import { Footer } from "../components/Footer";
import { CloudCanvas } from "../components/CloudCanvas";
import { usePageMeta } from "../hooks/usePageMeta";

export default function PublicSite() {
  usePageMeta({
    title: "Amyu | Tiramisus artisanaux fait maison — Carcassonne",
    description:
      "Amyu — tiramisus artisanaux fait maison à Carcassonne. Retrait sur point de rendez-vous à Carcassonne (Aude, 11). Kinder Bueno, Caramel Spéculoos, Choco Noisette, Fraise Pistache, Mangue Passion.",
    canonical: "https://amyu.fr/",
  });
  return (
    <>
      <CloudCanvas />
      <Header />
      <main className="relative" style={{ zIndex: 10 }}>
        <Hero />
        <Reassurance />
        <Gourmandises />
        <LoyaltyBanner />
        <Story />
        <Reviews />
        <ZoneLivraison />
        <Galerie />
        <FaqContact />
      </main>
      <Footer />
    </>
  );
}
